import { z } from 'zod'
import { AccountStatus } from '~/enums/account-status-code'
import { TrueFalse } from '~/enums/true-false'
import { listRequestDataSchema } from './list-request-data'

/**
 * 帳號 - 查詢多筆 Request Schema
 */
export const getAccountListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 帳號/姓名 - 模糊查詢 */
    q: z.string().optional(),
    /** 角色 */
    roleCode: z.string().optional(),
    /** 是否啟用 - 空值為全部 */
    isEnable: z.array(z.nativeEnum(TrueFalse)).optional(),
    /** 審核狀態 */
    statusCode: z.nativeEnum(AccountStatus).optional()
  })
)

/**
 * 帳號 - 查詢多筆 Request
 */
export interface GetAccountListRequest
  extends z.infer<typeof getAccountListRequestSchema> {}
